// JavaScript for Carousel Navigation
document.addEventListener('DOMContentLoaded', function() {
  const prevButton = document.querySelector('.carousel-button.prev');
  const nextButton = document.querySelector('.carousel-button.next');
  const carousel = document.querySelector('.carousel');
  
  let scrollAmount = 0;
  const carouselWidth = carousel.offsetWidth;

  prevButton.addEventListener('click', () => {
    scrollAmount -= carouselWidth;
    carousel.scrollTo({ left: scrollAmount, behavior: 'smooth' });
  });

  nextButton.addEventListener('click', () => {
    scrollAmount += carouselWidth;
    carousel.scrollTo({ left: scrollAmount, behavior: 'smooth' });
  });
});